import { Component, Input, OnInit } from '@angular/core';

interface FieldFAQ {
  fieldName: string;
  faqs: { question: string, answer: string }[];
}
@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})

export class FaqsComponent implements OnInit {
  @Input() fieldName!: string;

  selectedFAQ: FieldFAQ | undefined;

  constructor() { }

  ngOnInit(): void {
    this.getFAQData(this.fieldName);
  }

  fieldsFAQ: FieldFAQ[] = [
    {
      fieldName: 'Razão Social',
      faqs: [
        { question: 'O que é a Razão Social?', answer: 'A Razão Social é o nome oficial da empresa registrado nos órgãos governamentais.' },
        { question: 'Por que é obrigatória?', answer: 'É necessária para identificar legalmente a empresa no contrato.' }
      ]
    },
    {
      fieldName: 'Nome Fantasia',
      faqs: [
        { question: 'O que é o Nome Fantasia?', answer: 'O Nome Fantasia é o nome pelo qual a empresa é popularmente conhecida e que utiliza em suas atividades comerciais.' },
        { question: 'Por que é obrigatório?', answer: 'É utilizado para fins de marketing e comunicação com o público.' },
      ]
    },
    {
      fieldName: 'CNPJ',
      faqs: [
        { question: 'O que é o CNPJ?', answer: 'O CNPJ (Cadastro Nacional da Pessoa Jurídica) é o número de registro da empresa na Receita Federal.' },
        { question: 'Quantos caracteres o CNPJ deve ter?', answer: 'O CNPJ deve ter exatamente 14 caracteres numéricos.' },
        { question: 'Por que é obrigatório?', answer: 'É necessário para a identificação fiscal da empresa.' }
      ]
    },
    {
      fieldName: 'Inscrição Municipal',
      faqs: [
        { question: 'O que é a Inscrição Municipal?', answer: 'É o número de registro da empresa na prefeitura do município onde está localizada.' },
        { question: 'Quando devo informar a Inscrição Municipal?', answer: 'Informe a Inscrição Municipal se a empresa estiver registrada na prefeitura local.' },
      ]
    },
    {
      fieldName: 'Inscrição Estadual',
      faqs: [
        { question: 'O que é a Inscrição Estadual?', answer: 'É o número de registro da empresa na Secretaria da Fazenda do estado.' },
        { question: 'Quando devo informar a Inscrição Estadual?', answer: 'Informe a Inscrição Estadual se a empresa estiver registrada para fins de ICMS (Imposto sobre Circulação de Mercadorias e Serviços).' },
      ]
    },
    {
      fieldName: 'Logotipo',
      faqs: [
        { question: 'Como faço para adicionar o logotipo da empresa?', answer: 'Use a opção de upload na aba correspondente para adicionar o logotipo.' },
        { question: 'Quais são os formatos de arquivo aceitos para o logotipo?', answer: 'Formatos comuns aceitos incluem JPEG, PNG, e GIF.' },
      ]
    },
    {
      fieldName: 'CNAE',
      faqs: [
        { question: 'O que é o CNAE?', answer: 'O CNAE (Classificação Nacional de Atividades Econômicas) é um código que identifica a atividade econômica principal da empresa.' },
        { question: 'Onde posso encontrar o código CNAE da minha empresa?', answer: 'O código CNAE pode ser encontrado no cartão do CNPJ da empresa ou no site da Receita Federal.' },
      ]
    },
    {
      fieldName: 'Registro ANS',
      faqs: [
        { question: 'O que é o Registro ANS?', answer: 'O Registro ANS é o número de registro da operadora de saúde na Agência Nacional de Saúde Suplementar.' },
        { question: 'Por que é obrigatório?', answer: 'É necessário para a regulamentação e funcionamento legal da operadora de saúde.' },
      ]
    },
    {
      fieldName: 'Endereço Principal',
      faqs: [
        { question: 'O que é o endereço principal?', answer: 'É o endereço oficial da sede da empresa.' },
        { question: 'Quais informações são necessárias para o endereço principal?', answer: 'CEP, Endereço, Número, Complemento, Bairro e Cidade.' },
      ]
    },
    {
      fieldName: 'CEP',
      faqs: [
        { question: 'CEP:', answer: 'Código de Endereçamento Postal.' },
      ]
    },
    {
      fieldName: 'Endereço',
      faqs: [
        { question: 'Endereço:', answer: 'Nome da rua ou avenida.' },
      ]
    },
    {
      fieldName: 'Número',
      faqs: [
        { question: 'Número:', answer: 'Número do prédio ou estabelecimento.' },
      ]
    },
    {
      fieldName: 'Complemento',
      faqs: [
        { question: 'Complemento:', answer: 'Detalhes adicionais do endereço, como apartamento ou sala.' },
      ]
    },
    {
      fieldName: 'Bairro',
      faqs: [
        { question: 'Bairro:', answer: 'Bairro onde a empresa está localizada.' },
      ]
    },
    {
      fieldName: 'Cidade',
      faqs: [
        { question: 'Cidade:', answer: 'Cidade onde a empresa está localizada.' },
      ]
    },
    {
      fieldName: 'Contato',
      faqs: [
        { question: 'Quantos contatos posso adicionar?', answer: 'Você pode adicionar mais de um contato.' },
        { question: 'Quais informações são necessárias para cada contato?', answer: 'Nome, Departamento, E-mail, Telefone e Celular.' },
      ]
    },
    {
      fieldName: 'Nome',
      faqs: [
        { question: 'Nome:', answer: 'Nome da pessoa de contato.' },
      ]
    },
    {
      fieldName: 'Departamento',
      faqs: [
        { question: 'Departamento:', answer: 'Departamento da empresa ao qual a pessoa pertence.' },
      ]
    },
    {
      fieldName: 'E-mail',
      faqs: [
        { question: 'E-mail:', answer: 'Endereço de e-mail do contato.' },
      ]
    },
    {
      fieldName: 'Telefone',
      faqs: [
        { question: 'Telefone:', answer: 'Número de telefone fixo do contato.' },
      ]
    },
    {
      fieldName: 'Celular',
      faqs: [
        { question: 'Celular:', answer: 'Número de celular do contato.' },
      ]
    },
    {
      fieldName: 'CNS',
      faqs: [
        { question: 'Não sabe o número?', answer: 'Clique aqui!' },
      ]
    },

  ];

  getFAQData(fieldName: string) {
    this.selectedFAQ = this.fieldsFAQ.find(field => field.fieldName === fieldName);
  }
}
